import React from "react";
import { connect } from "react-redux";
import SeguimientoSiniestrosAutos from "./seguimientoSiniestros.cmpt";
import Gmm from "./gmm.cmpt";
import MulticanalSeguimiento from "../gnp-multicanal/multicanalSeguimiento.cmpt"

const mapState = (state) => {

	return {
		loading: state.global.loading,
		paso: state.olvide.paso,
		nombre: state.global.nombre,
		lastlogin: state.global.lastlogin,
		cliente: state.global.clienteUnico,
		ntfBullet: state.notificaciones.bullet,
		dispositivo: state.global.dispositivo,
		autos: state.polizas.autos,
		gm: state.polizas.gm,
		danios: state.polizas.danios
	};
};

class RamosSiniestros extends React.Component {	

	
	seleccionRamo = (ramo) => {
		var click = false;
		var estadoTemporal = {
			gmmClass: "",
			autosClass: "",				
			daniosClass: "",				
			mostrarAutos : false,
			mostrarGmm : false,
			mostrarDanios : false,
			secondMenuTitle : "",
			showGmm: false,
			showAutos: false,
			showDanios: false
		};			
		switch (ramo) {
		case "gmm":			
			estadoTemporal.gmmClass = "active";	
			estadoTemporal.mostrarGmm = true;
			estadoTemporal.secondMenuTitle = "GMM";
			estadoTemporal.showGmm = true;
			break;
		case "autos":			
			estadoTemporal.autosClass = "active";
			estadoTemporal.mostrarAutos = true;
			estadoTemporal.secondMenuTitle = "Autos";
			estadoTemporal.showAutos = true;
			break;		
		case "danios":			
			estadoTemporal.daniosClass = "active";
			estadoTemporal.mostrarDanios = true;
			estadoTemporal.secondMenuTitle = "Daños";
			estadoTemporal.showDanios = true;
			break;		
		default:
		}	
								
		this.setState(estadoTemporal);
		this.showMobileTabs();
	}
	
	
	componentWillMount(){

		let ingresoHospitalario = window.localStorage.getItem("ingresoHospitalario");
		let valoresIngresoHospitalario = window.localStorage.getItem("valoresIngresoHospitalario");

		if(![null, undefined, ''].includes(ingresoHospitalario) && ![null, undefined, ''].includes(valoresIngresoHospitalario)) {
			
			this.setState({
					gmmClass : "active",
					mostrarGmm : true,
					showGmm: true,
					tabActiva: "ingresoHospitalario" ,
					valoresHospital : valoresIngresoHospitalario ,
				});

				window.localStorage.removeItem("ingresoHospitalario");
				window.localStorage.removeItem("valoresIngresoHospitalario");

			} else {
				this.setState({
					tabActiva: null ,
					valoresHospital : null 
				})

			} 
		}
	

	showMobileTabs = () => {
		var arrowIndexTabs;
		if (this.state.arrowIndexTabs == 1) {
			arrowIndexTabs = 0;
		} else if (this.state.arrowIndexTabs == 0) {
			arrowIndexTabs = 1;
		}

		this.setState({
			"mobileTabs": !this.state.mobileTabs,
			"arrowIndexTabs": arrowIndexTabs,
		});
	}
	
	state = {
			gmmClass : "",
			autosClass : "",
			daniosClass : "",
			mostrarAutos : false,
			mostrarGmm : false,
			mostrarDanios : false,
			secondMenuTitle: "GMM",
			arrowOrange: [
				require("../img/arrow-down.svg"),
				require("../img/arrow-up.svg")
			],
			arrowIndexTabs: 0,
			showGmm: true,
			showAutos: false,			
			showDanios: false,			
			mobileTabs: false
	}

		
	render() {
    	return <div>
			{ (this.props.autos.length + this.props.gm.length + this.props.danios.length) > 0 &&
	    	<div className="second-menu text-center hide-mobile">				
			<ul className="clearfix">
				{ this.props.gm.length > 0 &&
				<li><a onClick={this.seleccionRamo.bind(this, "gmm")} className={this.state.gmmClass}>GMM</a></li>
				}
				{ this.props.autos.length > 0 &&
				<li><a onClick={this.seleccionRamo.bind(this, "autos")} className={this.state.autosClass}>Autos</a></li>
				}
				{ this.props.danios.length > 0 &&
				<li><a onClick={this.seleccionRamo.bind(this, "danios")} className={this.state.daniosClass}>Daños</a></li>
				}
			</ul>
			</div>
			}
			{ (this.props.autos.length + this.props.gm.length + this.props.danios.length) == 0 &&
				<div style={{"text-align": "center"}}>
				<p style={{"display":"block", "margin-top":"75px", "margin-right":"auto", "margin-left":"auto", "color":"#666666", "font-size": "25px"}}>Por el momento no cuentas con ninguna p&oacute;liza</p>
				<p style={{"display":"block", "margin-bottom":"125px", "margin-right":"auto", "margin-left":"auto", "color":"#666666", "font-size": "25px"}}>contratada</p>
				</div>
			}
		   <div className="second-menu text-center show-mobile">
			<div className="second-menu-select-mobile">
				<p onClick={this.showMobileTabs}>{this.state.secondMenuTitle} <img src={this.state.arrowOrange[this.state.arrowIndexTabs]}></img></p>
				{ this.state.mobileTabs &&
					<ul>
						<li onClick={this.seleccionRamo.bind(this, "gmm")}>
							<button disabled={this.state.mostrarGmm}>GMM</button>
							<div className={this.state.showGmm ? "active" : ""}></div>
						</li>
						<li onClick={this.seleccionRamo.bind(this, "autos")}>
							<button disabled={this.state.mostrarAutos}>Autos</button> 
							<div className={this.state.showAutos ? "active" : ""}></div>
						</li>				
						<li onClick={this.seleccionRamo.bind(this, "danios")}>
							<button disabled={this.state.mostrarDanios}>Daños</button> 
							<div className={this.state.showDanios ? "active" : ""}></div>
						</li>						
					</ul>
				}
			</div>
		   </div>		   
		   
		   {this.state.mostrarAutos &&
			   <SeguimientoSiniestrosAutos />
			}
		   {this.state.mostrarGmm &&
			   <Gmm tabActiva={this.state.tabActiva} valoresHospital ={this.state.valoresHospital} />
			}
			{this.state.mostrarDanios &&
			   <MulticanalSeguimiento />
			}
	   </div>  
	}
}



export default connect(mapState) (RamosSiniestros);



// WEBPACK FOOTER //
// ./src/seguimiento-siniestros/ramosSiniestros.cmpt.js